import React, { useEffect, useRef } from "react";
import AM from './Aurelien.png';
import CM from './Catherine.png';
import FH from './Frantz.png';
import GC from './Gaetan.png';
import ALV from './Aymeric.png';
import GS from './GIOVANNI.png';
import EL from './Eddy.png';
import BC from './Brice.png';
import './Personnages.css';

const Personnage = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("animate");
                    } else {
                        entry.target.classList.remove("animate"); // permet de relancer l'anim
                    }
                });
            },
            { threshold: 0.1 }
        );

        const elements = containerRef.current.querySelectorAll(".personnage");
        elements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <section className='div_equipe' ref={containerRef} aria-label="Présentation de l'équipe">
            <article className="personnage" role="listitem">
                <img src={AM} alt="Portrait d'Aurélien, technicien informatique et réseau confirmé" />
                <div className="div_equipe_titre">
                    <h3>AURÉLIEN</h3>
                    <p>Dirigeant, expert en informatique et réseaux</p>
                </div>
                <p>Spécialités : Réseaux • Téléphonie • Messagerie • Sauvegardes de données</p>

            </article>

            <article className="personnage" role="listitem">
                <img src={CM} alt="Portrait de Catherine, assistante de direction et commerciale" />
                <div className="div_equipe_titre">
                    <h3>CATHERINE</h3>
                    <p>Assistante de direction et commerciale.</p>
                </div>
                <p>Spécialité : Gestion relation client - Experte audits contractuels</p>
            </article>
            <article className="personnage" role="listitem">
                <img src={GS} alt="Portrait de Giovanni, Commercial " />
                <div className="div_equipe_titre">
                    <h3>GIOVANNI</h3>
                    <p>Responsable – Technico-Commercial</p>
                </div>
                <p>Spécialités : Accompagnement client • Solutions informatiques • Réseaux & téléphonie</p>

            </article>

            <article className="personnage" role="listitem">
                <img src={FH} alt="Portrait de Frantz, spécialiste dépannage PC et administration serveurs" />
                <div className="div_equipe_titre">
                    <h3>FRANTZ</h3>
                    <p>Technicien Informatique et Réseaux – Expérimenté</p>
                </div>
                <p>Spécialités : Administration réseaux, administration serveurs, sauvegarde de données, postes clients, NAS, imprimantes et Microsoft Office 365.</p>

            </article>

            <article className="personnage" role="listitem">
                <img src={GC} alt="Portrait de Gaëtan, technicien informatique et réseau polyvalent" />
                <div className="div_equipe_titre">
                    <h3>GAËTAN</h3>
                    <p>Technicien Informatique et Réseaux – Expérimenté</p>
                </div>
                <p>Spécialités : Administration réseaux, administration serveurs, postes clients, NAS, imprimantes, alarmes & sécurité, téléphonie et Microsoft Office 365.</p>


            </article>
            

            <article className="personnage" role="listitem">
                <img src={ALV} alt="Portrait de Aymeric, Alternant Commercial en informatique" />
                <div className="div_equipe_titre">
                    <h3>AYMERIC</h3>
                    <p>Développeur Web et D'application</p>
                </div>
                <p>Spécialités : Dépannage informatique • Développement web et applicatif </p>

            </article>
            <article className="personnage" role="listitem">
                <img src={EL} alt="Portrait de Aymeric, Alternant Commercial en informatique" />
                <div className="div_equipe_titre">
                    <h3>EDDY</h3>
                    <p>Technicien Informatique et Réseaux expérimenté</p>
                </div>
                <p>Spécialités : Téléphonie, administration réseaux, administration serveurs, Zeendoc, sauvegarde de données, postes clients, NAS, imprimantes et Microsoft Office 365.</p>

            </article>
            <article className="personnage" role="listitem">
                <img src={BC} alt="Portrait de Aymeric, Alternant Commercial en informatique" />
                <div className="div_equipe_titre">
                    <h3>BRICE</h3>
                    <p>Technicien Alarmes et Sécurité expérimenté</p>
                </div>
                <p>Spécialités : Maintenance, installation, paramétrage et remise en conformité des systèmes d’alarmes et de sécurité. </p>

            </article>


        </section>

    );
};

export default Personnage;
